import BaseComponent from '../../../../../base/base_component';
import DOM from '../../../../../utils/dom';
import _ from '../../../../../utils/underscore';

let pcView = require('./pc_layout.html');

export default class SpainGameStripePC extends BaseComponent {
    static CLASS = 'SpainGameStripePC';


    init(params) {
        params = params || {};
        params.innerHtml = pcView;
        super.init(params);
    }

    setRegulationData(regulationData) {
        regulationData = regulationData || {};

        this._setValueFor('session_balance', regulationData.sessionBalance);
        this._setValueFor('session_bets', regulationData.sessionTotalBet);
        this._setValueFor('session_wins', regulationData.sessionTotalWin);
    }

    _setValueFor(sectionName, value) {
        if (_.isNullOrUndefined(value)) {
            value = 0;
        }
        DOM.text(this.querySelector('#' + sectionName).querySelector('#value'),
            this.serviceFactory.currencyService().formatMoney(value));
    }
}